<div class="steps-cobranding-header">
	<div class="container d-flex align-items-center justify-content-between py-2 py-md-3 mh-landing-aic-header">
		<!-- Loghi co-branding -->
		<div class="d-flex align-items-center gap-3">
			@if (tenantId === 2) {
				<a [href]="themeService.getLandingUrl()" class="d-flex align-items-center text-decoration-none">
					<img src="/assets/images/PIB Italia Broker_logo.png" alt="PIB Italia broker" class="landing-logo-xl" />
				</a>
				<span class="landing-header-divider">|</span>
				<div class="d-flex align-items-center gap-2">
					<span class="landing-footer-powered" style="color: rgba(0,0,0,0.35);">IN PARTNERSHIP WITH</span>
					<img src="/assets/img/aic/logo.png" alt="AIC" class="landing-logo-aic" />
				</div>
			} @else {
				<a [href]="themeService.getLandingUrl()" class="d-flex align-items-center text-decoration-none">
					<img [src]="themeService.getLogoUrl()" alt="Logo" class="landing-logo" />
				</a>
				<span class="landing-header-divider">|</span>
				<div class="d-flex align-items-center gap-2">
					<span class="landing-footer-powered" style="color: rgba(0,0,0,0.35);">Powered by</span>
					<img src="/assets/images/logo_pib.svg" alt="PIB Italia broker" class="landing-logo" />
				</div>
			}
		</div>
		<!-- Torna alla home -->
		<!-- <button class="steps-header-back-btn" type="button" (click)="tornaAllaHome()">
			<i class="bi bi-arrow-left"></i>
			<span class="d-none d-md-inline">Torna alla home</span>
		</button> -->
	</div>
	<app-steps-progress-bar></app-steps-progress-bar>
</div>
